import React, { useState } from "react";

import { Link } from "react-router-dom";
import "./AuthForm.css";

import AuthUser from "../../services/AuthUser";


// Adjust the path as needed

const AuthForm = () => {
  const { http, setToken } = AuthUser();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [emailChecked, setEmailChecked] = React.useState(false);
  const [emailExists, setEmailExists] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [showForgotPasswordForm, setShowForgotPasswordForm] = useState(false);
  const [otpSentMessage, setOtpSentMessage] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState('');

  const [resetStep, setResetStep] = useState('identifier'); // 'identifier' | 'otp' | 'newPassword'
  const [resetIdentifier, setResetIdentifier] = useState('');
  const [resetOtp, setResetOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');


const [showCreateAccount, setShowCreateAccount] = useState(false);
const [registerName, setRegisterName] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
const [registerMobile, setRegisterMobile] = useState("");
const [registerCity, setRegisterCity] = useState("");
const [registerPassword, setRegisterPassword] = useState("");

const [showOtpLogin, setShowOtpLogin] = useState(false);
const [otpMobile, setOtpMobile] = useState("");
const [otpCode, setOtpCode] = useState("");
const [otpStep, setOtpStep] = useState(1); // 1 = enter mobile, 2 = enter OTP

  const [identifier, setIdentifier] = useState(""); // email or phone for check

  const [registerConfirmPassword, setRegisterConfirmPassword] = useState("");
  const [isEmailDisabled, setIsEmailDisabled] = useState(false);



const [isEmailChecked, setIsEmailChecked] = useState(false);

const [isMobileDisabled, setIsMobileDisabled] = useState(false);
const [isMobileChecked, setIsMobileChecked] = useState(false);


  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  // const handleCheckEmail = async () => {
  //   setError(null);

  //   if (!email) {
  //     setError("Email or phone number is required.");
  //     return;
  //   }

  //   try {
  //     const response = await http.post('/authcheck',
  //       { identifier: email }, // <-- send as 'identifier'
  //       {
  //         headers: { 'Content-Type': 'application/json' },
  //       }
  //     );

  //     if (response.data.exists) {
  //       setEmailExists(true);
  //       setEmailChecked(true);
  //     } else {
  //       // Should not happen if backend handles logic correctly
  //       setError("Account does not exist.");
  //     }
  //   } catch (err) {
  //     if (err.response && err.response.status === 404) {
  //       setError(err.response.data.message || "Account does not exist.");
  //       setEmailExists(false);
  //       setEmailChecked(false);
  //     } else if (err.response?.data?.errors?.identifier) {
  //       setError(err.response.data.errors.identifier[0]);
  //     } else {
  //       setError(err.message || "Something went wrong");
  //     }
  //   }
  // };

const handleCheckIdentifier = async () => {
  setError(null);
  setShowCreateAccount(false); // reset state

  if (!email) {
    setError("Email or phone number is required.");
    return;
  }

  try {
    const response = await http.post(
      '/authcheck',
      { identifier: email }, // can be email or phone
      { headers: { 'Content-Type': 'application/json' } }
    );

    // If account exists → proceed to login/password
    if (response.data.exists) {
      setEmailExists(true);
      setEmailChecked(true);
      // Optionally, prefill the fields with existing info if needed
    }
  } catch (err) {
    // ❌ User not found → open Create Account form
    if (err.response && err.response.status === 404) {
      setShowCreateAccount(true);
      setEmailChecked(false);
      setEmailExists(false);

      // Prefill email or phone based on input
      const identifier = email.trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier)) {
        setRegisterEmail(identifier);
        setIsEmailDisabled(true);
        setRegisterMobile(""); // empty, user can fill
      } else if (/^[0-9]{10,15}$/.test(identifier)) {
        setRegisterMobile(identifier);
        setRegisterEmail(""); // user can fill
        setIsEmailDisabled(false);
      }

      return;
    }

    // Validation error from server
    if (err.response?.data?.errors?.identifier) {
      setError(err.response.data.errors.identifier[0]);
    } else {
      setError("Something went wrong");
    }
  }
};


  // Handle form submission
  
const submitForm = async (e) => {
  e.preventDefault();
  setError(null);

  // If the identifier has not been checked yet,
  // pressing Enter should check the email/mobile first.
  if (!emailChecked) {
    await handleCheckIdentifier();
    return;
  }

  // Only submit login when the password screen is visible.
  if (!emailExists) {
    return;
  }

  if (!password.trim()) {
    setError("Please enter your password.");
    return;
  }

  setLoading(true);

  try {
    const response = await http.post(
      "/login",
      {
        identifier: email,
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (isLogin) {
      setToken(response.data.user, response.data.access_token);
    }
  } catch (err) {
    const msg =
      err.response?.data?.message || "Incorrect password!";

    if (
      msg.toLowerCase().includes("multiple accounts") ||
      msg.toLowerCase().includes("use your email")
    ) {
      setError(msg);
      setEmailChecked(false);
      setEmailExists(false);
      setEmail("");
      setPassword("");
      setConfirmPassword("");
    } else {
      setError(msg);
    }
  } finally {
    setLoading(false);
  }
};



  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await http.post('/forgot-password', {
        email: email,
      });

      alert(response.data.message); // Or show it in UI
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
  };


  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      maxWidth: "600px",
      margin: "0 auto",
    },
    input: {
      flex: "1",
      padding: windowWidth < 480 ? "8px 10px" : "10px 14px",
      fontSize: windowWidth < 480 ? "14px" : windowWidth < 768 ? "15px" : "16px",
      borderRadius: "4px 0 0 4px",
      border: "1px solid #ccc",
      outline: "none",
      boxSizing: "border-box",
    },
    button: {
      padding: windowWidth < 480 ? "8px 10px" : "10px 14px",
      fontSize: windowWidth < 480 ? "14px" : windowWidth < 768 ? "15px" : "16px",
      cursor: "pointer",
      border: "1px solid #007bff",
      borderLeft: "none",
      backgroundColor: "#007bff",
      color: "white",
      borderRadius: "0 4px 4px 0",
      userSelect: "none",
    },
  };

  const handleBackToLogin = () => {
    setShowForgotPasswordForm(false);
    setEmailChecked(false);
    setEmailExists(false);
    setEmail('');
    setPassword('');
    setConfirmPassword('');
    setError(null);
  };

  const handleSendOtp = async () => {
    try {
      const response = await http.post('/send-reset-otp', { identifier: resetIdentifier });

      setResetStep('otp');
      if (response.data.message) {
        setOtpSentMessage(response.data.message);
        alert("OTP sent successfully.");
      }
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to send OTP');
    }
  };

  const handleVerifyOtp = async () => {
    setError(null);
    try {
      await http.post('/verify-reset-otp', {
        identifier: resetIdentifier,
        otp: resetOtp,
      });
      setResetStep('newPassword');
    } catch (err) {
      alert(err.response?.data?.message || 'Invalid OTP');
    }
  };

  const handleResetPassword = async () => {

    console.log(newPassword === confirmPassword);
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      await http.post('/reset-password', {
        identifier: resetIdentifier,
        otp: resetOtp,
        new_password: newPassword,
      });

      alert('Password reset successful! Please log in.');
      // Reset state
      setShowForgotPasswordForm(false);
      setResetStep('identifier');
      setResetIdentifier('');
      setResetOtp('');
      setNewPassword('');
      setConfirmPassword('');
      setError(null);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reset password');
    }
  };


const handleCreateAccount = async (e) => {
  e.preventDefault();

  // Confirm password validation
  if (registerPassword !== registerConfirmPassword) {
    setError("Passwords do not match!");
    return;
  }

  try {
    const payload = {
      name: registerName,
      email: registerEmail, // prefilled email if any
      mobile: registerMobile, // prefilled phone if any
      city: registerCity,
      password: registerPassword,
    };

    const response = await http.post("/register", payload);

    alert("Account created successfully!");

    // Auto login after registration
    setToken(response.data.user, response.data.access_token);

    // Reset form
    setRegisterName("");
    setRegisterEmail("");
    setRegisterMobile("");
    setRegisterCity("");
    setRegisterPassword("");
    setRegisterConfirmPassword("");
    setShowCreateAccount(false);
    setEmailChecked(false);
    setEmailExists(false);
    setIsEmailDisabled(false);
  } catch (err) {
    const responseData = err.response?.data;
    let errorMessage = "Registration failed";

    if (responseData) {
        if (responseData.errors) {
            // Get the first field's first error message
            const firstField = Object.keys(responseData.errors)[0];
            errorMessage = responseData.errors[firstField][0];
        } else if (responseData.message) {
            errorMessage = responseData.message;
        }
    }

    setError(errorMessage);
}

};

// SEND OTP
const handleSendLoginOtp = async () => {
  if (!otpMobile || otpMobile.length !== 10) {
    setError("Enter valid 10-digit mobile number");
    return;
  }

  try {
    await http.post("/send-otp", { mobile: otpMobile });
    setOtpStep(2); // move to OTP screen
    setError(null);
    alert("OTP sent successfully");
  } catch (err) {
    setError(err.response?.data?.message || "Failed to send OTP");
  }
};

// VERIFY OTP & LOGIN
const handleVerifyLoginOtp = async () => {
  if (!otpCode || otpCode.length !== 6) {
    setError("Enter valid 6-digit OTP");
    return;
  }

  try {
    const response = await http.post("/verify-otp", {
      mobile: otpMobile,
      otp: otpCode,
    });

    setToken(response.data.user, response.data.access_token); // auto login
    alert("Login successful!");

  } catch (err) {
    setError(err.response?.data?.message || "Invalid OTP");
  }
};



  return (
    <div className="bg-color">
      <div className="containerr h-100  d-flex justify-content-center align-items-center">
        <div className="containerr d-flex justify-content-center align-items-center">
          <div className="col-lg-7 h100 d-flex flex-column justify-content-center align-items-center bg-w">
            <div className="rounded text-black">
              <div className="user-log-img">
                <Link to="/">
                  <img src="assets/img/logo/header-logo10a.svg" alt="" />
                </Link>
                <img className="user-img" src="assets/img/images/Annual-Compliance-LLP.png" alt="" />
              </div>
              <div className="txtt text-center">
                <h4 className="user-login-txt">"Secure your legal needs with ease. Log in and take the next step towards hassle-free legal solutions."</h4>
              </div>
            </div>

          </div>
          <div className="col-lg-5 h100  d-flex flex-column  justify-content-center align-items-center bg-g">
            <div className=" card form-sec rounded-3 color text-black">
              <div className="card-body  mx-2">
                {!showForgotPasswordForm && !showCreateAccount && !showOtpLogin &&  (<form onSubmit={submitForm}>
                 





                  {/* Show email input only if email not checked */}
                  {!emailChecked && (
                    <>
                     <h4 className="text-center mb-4">Login</h4>
                    <div style={styles.container}>
                      <input
                        type="text"
                        id="identifier"
                        placeholder="Enter email or phone..."
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                         onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleCheckIdentifier();
    }
  }}
                        style={styles.input}
                        required
                      />
                      <button type="button" onClick={handleCheckIdentifier} style={styles.button} aria-label="Next">
                        ➔
                      </button>
                    </div>
                    </>
                  )}

                  {/* Show password input if email exists */}
                  {emailChecked && emailExists && (
                    <>
                     <h4 className="text-center mb-4">Enter Password</h4>
                      <div style={styles.container}>
                        <input
                          type="password"
                          id="password"
                          placeholder="Enter password..."
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={styles.input}
                          required
                        />
                        <button type="submit" style={styles.button}>
                          Login
                        </button>
                      </div>
                      <div style={{ textAlign: 'end', display: 'inline-block', float: 'right' }}>

                        <button
                          type="button"
                          onClick={handleBackToLogin}
                          style={{ fontSize: '14px', color: '#007bff', background: 'none', border: 'none' }}
                        >
                          ← Back to Login
                        </button>
                      </div>
                    </>
                  )}

                  {/* Forgot password link */}
                  <Link
                    to="#"
                    onClick={() => setShowForgotPasswordForm(true)}
                    style={{ fontSize: '14px', color: '#007bff', textDecoration: 'none' }}
                  >
                    Forgot Password?
                  </Link>

                  <button
  type="button"
  onClick={() => {
    setShowOtpLogin(true);
    setEmailChecked(false);
  }}
  className="btn btn-link mt-2"
  style={{ fontSize: "14px", width: "100%", textAlign: "center" }}
>
  Login via OTP
</button>



                  {/* Error messages */}
                  <div className="text-center error-text" style={{ maxWidth: '315px', margin: '1 auto', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                    {error && <p style={{ fontSize: '15px', marginTop: '3px' }}>{error}</p>}
                  </div>


                  {/* <div className="text-center error-text" style={{ maxWidth: '315px', margin: '1 auto', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                    {error?.email && Array.isArray(error.email) && error.email.length > 0 ? (
                      error.email.map((msg, index) => <p key={index}>{msg}</p>)
                    ) : error?.message ? (
                      <p style={{ fontSize: '15px', marginTop: '3px' }}
                      >{error.message}</p>
                    ) : error?.error ? (
                      <p style={{ fontSize: '15px', marginTop: '3px' }}
                      >{error.error}</p>
                    ) : null}
                  </div> */}




                </form>
                )}

               {showCreateAccount && (
  <div style={{ marginTop: "20px" }}>
    <h4 className="text-center mb-4">Create Account</h4>
    <form onSubmit={handleCreateAccount}>

      {/* Full Name */}
      <div style={styles.container}>
        <input
          type="text"
          placeholder="Full Name"
          value={registerName}
          onChange={(e) => setRegisterName(e.target.value)}
          style={styles.input}
          required
        />
      </div>

      {/* Email */}
      <div style={{ ...styles.container, marginTop: "12px" }}>
        <input
          type="text"
          placeholder="Email"
          value={registerEmail}
          disabled={isEmailDisabled && isEmailChecked} // disable if prefilled from check
          onChange={(e) => setRegisterEmail(e.target.value)}
          style={styles.input}
          required
        />
      </div>

      {/* Mobile */}
      <div style={{ ...styles.container, marginTop: "12px" }}>
        <input
          type="text"
          placeholder="Mobile Number"
          value={registerMobile}
          disabled={isMobileDisabled && isMobileChecked} // disable if prefilled from check
          onChange={(e) => setRegisterMobile(e.target.value)}
          style={styles.input}
          required
        />
      </div>

      {/* City */}
      <div style={{ ...styles.container, marginTop: "12px" }}>
        <input
          type="text"
          placeholder="City"
          value={registerCity}
          onChange={(e) => setRegisterCity(e.target.value)}
          style={styles.input}
          required
        />
      </div>

      {/* Password */}
      <div style={{ ...styles.container, marginTop: "12px" }}>
        <input
          type="password"
          placeholder="Create Password"
          value={registerPassword}
          onChange={(e) => setRegisterPassword(e.target.value)}
          style={styles.input}
          required
        />
      </div>

      {/* Confirm Password */}
      <div style={{ ...styles.container, marginTop: "12px" }}>
        <input
          type="password"
          placeholder="Confirm Password"
          value={registerConfirmPassword}
          onChange={(e) => setRegisterConfirmPassword(e.target.value)}
          style={styles.input}
          required
        />
      </div>

      {/* Error messages */}
      <div className="text-center error-text" style={{ maxWidth: '315px', margin: '1 auto', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
        {error && <p style={{ fontSize: '15px', marginTop: '3px' }}>{error}</p>}
      </div>

      {/* Submit */}
      <button
        type="submit"
        className="btn btn-primary mt-3"
        style={{ width: "100%" }}
      >
        Create Account
      </button>

      {/* Back to login */}
      <button
        type="button"
        className="btn btn-link mt-2"
        style={{ width: "100%" }}
        onClick={() => {
          setShowCreateAccount(false);
          setEmail("");
          setRegisterEmail("");
          setRegisterMobile("");
          setIsEmailDisabled(false);
          setIsMobileDisabled(false);
        }}
      >
        ← Back to Login
      </button>
    </form>
  </div>
)}



{showOtpLogin && (
  <div>
    <h4 className="text-center mb-4">Login with OTP</h4>

    {/* STEP 1 → ENTER MOBILE */}
    {otpStep === 1 && (
      <>
        <div style={styles.container}>
          <input
            type="text"
            placeholder="Enter mobile number"
            value={otpMobile}
            onChange={(e) => setOtpMobile(e.target.value)}
            style={styles.input}
            required
          />
          <button
            type="button"
            onClick={handleSendLoginOtp}
            style={styles.button}
          >
            Send OTP
          </button>
        </div>

        {/* 🔴 Show Errors HERE */}
        {error && (
          <div style={{
            color: "red",
            marginTop: "10px",
            textAlign: "center",
            fontSize: "14px"
          }}>
            {error}
          </div>
        )}

        <button
          className="btn btn-link mt-3"
          style={{ width: "100%" }}
          onClick={() => {
            setShowOtpLogin(false);
            setOtpStep(1);
            setOtpMobile("");
            setError(null);
          }}
        >
          ← Back to Login
        </button>
      </>
    )}

    {/* STEP 2 → ENTER OTP */}
    {otpStep === 2 && (
      <>
        <div style={styles.container}>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value)}
            style={styles.input}
            required
          />
          <button
            type="button"
            onClick={handleVerifyLoginOtp}
            style={styles.button}
          >
            Verify
          </button>
        </div>

        {/* 🔴 Show Errors HERE */}
        {error && (
          <div style={{
            color: "red",
            marginTop: "10px",
            textAlign: "center",
            fontSize: "14px"
          }}>
            {error}
          </div>
        )}

        <button
          className="btn btn-link mt-3"
          style={{ width: "100%" }}
          onClick={() => {
            setOtpStep(1);
            setOtpCode("");
            setError(null);
          }}
        >
          ← Change Mobile
        </button>
      </>
    )}
  </div>
)}



                {showForgotPasswordForm && (
                  <form onSubmit={(e) => e.preventDefault()}>
                  

                    {resetStep === 'identifier' && (
                      <>
                        <h4 className="text-center mb-4">Reset Password</h4>
                        <div style={styles.container}>
                          <input
                            type="text"
                            placeholder="Enter your email or phone"
                            value={resetIdentifier}
                            onChange={(e) => setResetIdentifier(e.target.value)}
                            style={styles.input}
                            required
                          />
                          <button
                            type="button"
                            onClick={handleSendOtp}
                            style={styles.button}
                          >
                            Send OTP
                          </button>
                        </div>
                      </>
                    )}

                    {resetStep === 'otp' && (
                      
                      <>
                        <h4 className="text-center mb-4">Enter OTP</h4>
                        <div style={styles.container}>
                          <input
                            type="text"
                            placeholder="Enter OTP"
                            value={resetOtp}
                            onChange={(e) => setResetOtp(e.target.value)}
                            style={styles.input}
                            required
                          />
                          <button
                            type="button"
                            onClick={handleVerifyOtp}
                            style={styles.button}
                          >
                            Verify OTP
                          </button>
                        </div>

                        {otpSentMessage && (
                          <div style={{ color: 'green', marginTop: '10px', fontSize: '14px' }}>
                            {otpSentMessage}
                          </div>
                        )}

                      </>
                    )}

                    {resetStep === 'newPassword' && (
                      <>
                       <h4 className="text-center mb-4">Enter New Password</h4>
                        <div style={styles.container}>
                          <input
                            type="password"
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            style={{ ...styles.input, borderRadius: '4px' }}

                            required
                          />
                        </div>

                        <div style={{ ...styles.container, marginBottom: '12px', marginTop: '12px' }}>
                          <input
                            type="password"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            style={{ ...styles.input, borderRadius: '4px' }}

                            required
                          />
                        </div>

                        {/* 🔴 Error message */}
                        {error && (
                          <div style={{ color: 'red', textAlign: 'center', marginBottom: '10px' }}>
                            {error}
                          </div>
                        )}


                        <button
                          type="button"
                          onClick={handleResetPassword}
                          style={{ ...styles.button, borderRadius: '4px' }}

                        >
                          Reset Password
                        </button>

                      </>
                    )}


                    <div style={{ textAlign: 'end', marginTop: '8px' }}>
                      <button
                        type="button"
                        onClick={() => {
                          setShowForgotPasswordForm(false);
                          setResetStep('identifier');
                          setResetIdentifier('');
                          setResetOtp('');
                          setNewPassword('');
                          setConfirmPassword('');
                          setError(null);
                        }}
                        style={{
                          fontSize: '14px',
                          color: '#007bff',
                          background: 'none',
                          border: 'none',
                        }}
                      >
                        ← Back to Login
                      </button>
                    </div>
                  </form>
                )}


              </div>
            </div>
            <div className="text-end  pt-1 mt-2 pb-2">
              <Link to="/" >Back to Home</Link>
            </div>

          </div>

        </div>

      </div>
    </div>
  );
};





export default AuthForm;
